import { render, staticRenderFns } from "./PurchaseDeliveryNote.vue?vue&type=template&id=d8824d06&"
import script from "./PurchaseDeliveryNote.vue?vue&type=script&lang=js&"
export * from "./PurchaseDeliveryNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports